export const API_URL = process.env.REACT_APP_API_URL;
export const AUTH_LOGIN = "admin/login";
export const AUTH_LOGOUT = "admin/logout";
export const CHANGE_PASSWORD = "admin/changePassword";

//meal package management
export const MEAL_LIST = "admin/meal/list";
export const MEAL_ADD = "admin/meal/add";
export const MEAL_UPDATE = "admin/meal/edit";
export const MEAL_DELETE = "admin/meal/delete";
export const REVIEW_EXPORT = "admin/review-list";

//reviews
export const REVIEW_LIST = "admin/review-list";
export const REVIEW_DETAIL = "admin/review-detail/";
export const REVIEW_UPDATE = "rating/edit";

//Manage category
export const CATEGORY_LIST = "admin/category/list";
export const CATEGORY_ADD = "admin/category/add";
export const CATEGORY_UPDATE = "admin/category/update";
export const CATEGORY_DELETE = "admin/category/remove";
export const CATEGORY_SUB = "admin/category/subCategory";

//refund transaction
export const REFUND_TRANSACTION_LIST = "admin/transaction/refund/list";
export const REFUND_TRANSACTION_CREATE = "admin/transaction/createRefund";
export const REFUND_DETAIL = "admin/transaction/refundDetail/";
export const COOLER_BAG_REFUND = "admin/transaction/createRefund/coolerBag";
export const REFUND_EXPORT = "admin/transaction/exportRefund";

//email template
export const EMAIL_TEMPLATE_LIST = "admin/emailTemplate/list";
export const EMAIL_TEMPLATE_UPDATE = "admin/emailTemplate/edit";

export const STAFF_ADD = "admin/create/staff";
export const STAFF_DELETE = "admin/remove/staff";

export const DIET_LIST = "admin/diet/list";
export const DIET_ADD = "admin/diet/add";
export const DIET_UPDATE = "admin/diet/edit";
export const DIET_DELETE = "admin/diet/delete";

export const INGREDIENT_LIST = "admin/ingredient/list";
export const INGREDIENT_ADD = "admin/ingredient/add";
export const INGREDIENT_UPDATE = "admin/ingredient/edit";
export const INGREDIENT_DELETE = "admin/ingredient/delete";
export const INGREDIENT_ALL_DELETE = "admin/ingredient/deleteAll";
export const INGREDIENT_EXPORT = "admin/export-ingredient";
export const INGREDIENT_IMPORT = "admin/import-ingredient";
export const INGREDIENT_SAMPLE_FILE = "admin/sample-file-ingredient";

export const SETTINGS_LIST = "setting/detail";
export const SETTINGS_UPDATE = "setting/edit";
export const UPLOAD_FILE = "setting/uploadFile";

export const USER_LIST = "admin/user/list";
export const USER_DETAILS = "admin/user/detail/";
export const USER_EDIT = "admin/user/edit";
export const USER_EXPORT = "admin/export-user";
export const DASHBOARD = "admin/dashBoardData";
export const DASHBOARD_REVENUE = "admin/revenue";

export const CONTACT_US = "contactUs/list";
export const CONTACT_UPDATE = "contactUs/edit/";

export const ORDER_MANAGEMENT_LIST = "admin/order/list";
export const GET_GROUPED_ORDER_INFO = "admin/groupedOrder/list";
export const ORDER_DETAILS = "admin/order/detail/";
//export const ORDER_EXPORT = "admin/order/download";
export const ORDER_EXPORT = "admin/order/list";
export const ORDER_SINGLE_EXPORT = "admin/groupedOrder/today";
export const DISH_ORDER_EXPORT = "admin/groupedOrder/dish_csv";
export const ORDER_STAFF_LIST = "admin/order/staff/list";
export const ORDER_UPDATE = "admin/order/update/";
export const GET_ORDER_DETAILED_INFO = "admin/order/myOrderList";
export const CANCEL_ORDER = "admin/groupedOrder/cancel";
export const GET_GROUPED_ORDER_INFO_SINGLE = "admin/groupedOrder/detail";
export const SAVE_INGREDIENTS = "admin/groupedOrder/update_ingredient";

export const SINGLE_ORDER_MANAGEMENT_LIST = "admin/groupedOrder/today";

export const ORDER_STATUS = "admin/order/update/prepareMeal/";
export const GROUPED_ORDER_STATUS_CHANGE = "admin/groupedOrder/update/";

export const GET_NEW_ORDER_LIST = "admin/order/mealorder/list";

export const CONTENT_PAGES_LIST = "admin/pages/list";
export const CONTENT_PAGES_ADD = "admin/pages/add";
export const CONTENT_PAGES_UPDATE = "admin/pages/edit";
export const CONTENT_PAGES_DELETE = "admin/pages/delete";

export const FAQ_LIST = "admin/faqs/list";
export const FAQ_ADD = "admin/faqs/add";
export const FAQ_UPDATE = "admin/faqs/edit";
export const FAQ_DELETE = "admin/faqs/delete";

export const RECIPE_DETAILS = "recipe/detail/";
export const RECIPE_LIST = "recipe/list";
export const RECIPE_DOWNLOAD = "recipe/download-image";
export const RECIPE_ADD = "recipe/add";
export const RECIPE_UPDATE = "recipe/edit";
export const RECIPE_DELETE = "recipe/delete";
export const RECIPE_IMPORT = "admin/import-recipe";
export const RECIPE_EXPORT = "admin/export-recipe";
export const RECIPE_DELETE_ALL = "admin/recipe/removeAll";

export const BLOG_LIST = "admin/blog/list";
export const BLOG_ADD = "admin/blog/add";
export const BLOG_UPDATE = "admin/blog/edit";
export const BLOG_DELETE = "admin/blog/delete";

export const HOME_PAGE_DETAILS = "admin/home/detail";
export const HOME_PAGE_UPDATE = "admin/home/edit";

export const PROMO_CODE_LIST = "admin/promoCode/list";
export const PROMO_CODE_ADD = "admin/promoCode/add";
export const PROMO_CODE_UPDATE = "admin/promoCode/edit";
export const PROMO_CODE_DELETE = "admin/promoCode/delete";
export const PROMO_USER_DROPDOWN = "admin/user/promo/list";

export const EQUIPMENT_LIST = "admin/equipment/list";
export const EQUIPMENT_ADD = "admin/equipment/add";
export const EQUIPMENT_UPDATE = "admin/equipment/edit";
export const EQUIPMENT_DELETE = "admin/equipment/delete";

export const GET_ABOUT_US_SUSTAINABILITY_CONTENT = "admin/aboutUs/detail";
export const UPDATE_ABOUT_US_SUSTAINABILITY_CONTENT = "admin/aboutUs/edit";

export const GET_PARTNERSHIP_CONTENT = "admin/affliates/detail";
export const UPDATE_PARTNERSHIP_CONTENT = "admin/affliates/edit";

export const FAQ_PAGE_CONTENT_DETAIL = "admin/faqsContent/detail";
export const FAQ_PAGE_UPDATE = "admin/faqsContent/edit";

export const CONTACT_US_CONTENT_DETAIL = "admin/contactUs/detail";
export const CONTACT_US_UPDATE = "admin/contactUs/edit";

// Product Managemnt
export const ADD_PRODUCT = "admin/product/add";
export const GET_PRODUCT = "admin/product/list";
export const DELETE_PRODUCT = "admin/product/remove";
export const UPDATE_PRODUCT = "admin/product/update";
export const PRODUCT_DETAIL = "admin/product/detail";

// Product Banner
export const ADD_PRODUCT_BANNER = "admin/product-banner";
export const UPDATE_PRODUCT_BANNER = "admin/product-banner";
export const DELETE_PRODUCT_BANNER = "admin/product-banner";
export const GET_PRODUCT_BANNER = "admin/product-banner";

//DietaryPreferences
export const ADD_DIETARY_PREFRERENCES = "admin/dietary/add";
export const GET_DIETARY_PREFRERENCES = "admin/dietary/list";
export const DELETE_DIETARY_PREFRERENCES = "admin/dietary/remove";
export const UPDATE_DIETARY_PREFRERENCES = "admin/dietary/update";
export const DETAILS_DIETARY_PREFRERENCES = "admin/dietary/detail";

// Delivery Information
export const ADD_PRODUCT_SETTINGS = "admin/product-settings";
export const GET_PRODUCT_SETTINGS = "admin/product-settings";
export const UPDATE_PRODUCT_SETTINGS = "admin/product-settings";

//Store Ratings

export const GET_STORE_RATINGS = "rating/list";
export const RATINGS_DETAILS = "rating/detail";
export const RATINGS_STATAUS = "rating/action";
export const RATINGS_DELETE = "rating/delete";

// order management
export const groupedOrder = "admin/groupedOrder/updateProduct";
